import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/Modal";
import AthleteScore from "../../../components/athlete-scores/athlete-score";
import CoachInfo from "./CoachInfo";
import FavoriteAthletesList from "./FavoriteAthletesList";

const CoachDetails = ({
  selectedCoach,
  backButtonClickEvent,
  athletesLiked = [],
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedAthlete, setSelectedAthlete] = useState(null);

  useEffect(() => {
    document.body.style.overflow = "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleViewClick = (athlete) => {
    setSelectedAthlete(athlete);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedAthlete(null);
  };

  return (
    <>
      <div className="bg-white p-4 border-gray-300 rounded-md shadow-lg h-full">
        <div className="athletes-list h-full event_details_mob md:absolute xl:relative lg:relative md:col-span-7 xl:col-span-7 xl:space-y-0 xl:bg-transparent xl:border-gray-300 p-0 md:space-y-0 md:top-0 xl:top-0 lg:top-0">
          <div className="text-blue-600 pt-6 px-6 md:visible xl:hidden lg:hidden sm:visible">
            <NavLink onClick={() => backButtonClickEvent(false)}>
              <FontAwesomeIcon icon={faChevronLeft} /> Back
            </NavLink>
          </div>
          <div className="p-4 xl:p-0 lg:p-0">
            <CoachInfo selectedCoach={selectedCoach} />
            <FavoriteAthletesList
              athletesLiked={athletesLiked}
              onViewAthlete={handleViewClick}
            />
          </div>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={handleCloseModal}>
        {selectedAthlete && (
          <AthleteScore
            userId={selectedAthlete.userId}
            showOffers={true}
            showTrackittScore={true}
            showPositionScore={true}
            searchEvent={false}
            showProfile={true}
            showRank={true}
            showLikes={true}
          />
        )}
      </Modal>
    </>
  );
};

export default CoachDetails;
